import React from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  Box,
  Collapse,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useTranslation } from "react-i18next";
import { TAppSublists } from "src/welcome/features/LandPage/LandPage";

export default function LandPageAppsDialog({
  openApplicationDialog,
  setOpenApplicationDialog,
  applicationSublistsOpen,
  setApplicationSublistsOpen,
}: {
  openApplicationDialog: boolean;
  setOpenApplicationDialog: React.Dispatch<React.SetStateAction<boolean>>;
  applicationSublistsOpen: TAppSublists;
  setApplicationSublistsOpen: React.Dispatch<
    React.SetStateAction<TAppSublists>
  >;
}) {
  const { t } = useTranslation();

  const sublists = [
    {
      label: t(
        "Αναρτώμενες στο ΓΕΜΗ απ’ ευθείας και με ευθύνη της εταιρείας (χωρίς παρέμβαση των Υπηρεσιών ΓΕΜΗ)",
      ),
      in: applicationSublistsOpen.a,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          a: !applicationSublistsOpen.a,
        });
      },
      items: [
        t("ΑΕ - Πρόσκληση σε Γενική Συνέλευση"),
        t(
          "ΑΕ - Πρόσκληση για ενάσκηση δικαιώματος προτίμησης της παρ.9 του αρ.13 του Κ.Ν. 2190/1920",
        ),
        t("ΑΕ - (Αυτοματοποιημένη Καταχώριση) Ιστοσελίδα"),
        t("ΑΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t(
          "ΑΕ - (Αυτοματοποιημένη Καταχώριση) Πιστοποίηση Καταβολής Αρχικού Μετοχικού Κεφαλαίου",
        ),
        t(
          "ΑΕ - (Αυτοματοποιημένη Καταχώριση) Ισολογισμός Χρήσης 2019 και μετά χωρίς εκλογή ελεγκτών",
        ),
        t("ΑΕ - (Αυτοματοποιημένη Καταχώριση) Έκθεση Εκτίμησης"),
        t("ΟΕ - (ΟΕ) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης"),
        t("ΟΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t(
          "ΟΕ - (Αυτοματοποιημένη Καταχώριση) Ισολογισμός Χρήσης 2019 και μετά χωρίς εκλογή ελεγκτών",
        ),
        t("ΟΕ - (Αυτοματοποιημένη Καταχώριση) Ιστοσελίδα"),
        t(
          "ΣυνΠΕ - (ΣυνΠΕ) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t("ΣυνΠΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t("ΕΕ - (ΕΕ) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης"),
        t("ΕΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t(
          "ΕΕ - (Αυτοματοποιημένη Καταχώριση) Ισολογισμός Χρήσης 2019 και μετά χωρίς εκλογή ελεγκτών",
        ),
        t("ΕΕ - (Αυτοματοποιημένη Καταχώριση) Ιστοσελίδα"),
        t("ΕΠΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t("ΕΠΕ - (Αυτοματοποιημένη Καταχώριση) Ιστοσελίδα"),
        t(
          "ΕΠΕ - (Αυτοματοποιημένη Καταχώριση) Ισολογισμός Χρήσης 2019 και μετά χωρίς εκλογή ελεγκτών",
        ),
        t("ΕΠΕ - (Αυτοματοποιημένη Καταχώριση) Έκθεση Εκτίμησης"),
        t(
          "Κοινωνία - (Κοινωνία) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t(
          "Κοινωνία - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Συνεταιρισμός - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Ευρωπαϊκή Εταιρία (SE) - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Ευρωπαϊκή Συνεταιριστική Εταιρία (SCE) - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Κοινοπραξία - (Κοινοπραξία) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t(
          "Κοινοπραξία - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "ΑΤΟΜΙΚΗ - (Ατομική) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t(
          "ΕΝΩΣΗ ΠΡΟΣΩΠΩΝ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Αστική Εταιρία 784 Α.Κ. - (Αστική Εταιρία 784 Α.Κ.) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t(
          "Αστική Εταιρία 784 Α.Κ. - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t("ΙΚΕ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης"),
        t("ΙΚΕ - (Αυτοματοποιημένη Καταχώριση) Ιστοσελίδα"),
        t(
          "ΙΚΕ - (Αυτοματοποιημένη Καταχώριση) Πιστοποίηση Καταβολής Αρχικού Εταιρικού Κεφαλαίου",
        ),
        t(
          "ΙΚΕ - (Αυτοματοποιημένη Καταχώριση) Ισολογισμός Χρήσης 2019 και μετά χωρίς εκλογή ελεγκτών",
        ),
        t("ΙΚΕ - (Αυτοματοποιημένη Καταχώριση) Έκθεση Εκτίμησης"),
        t(
          "ΚΟΙ.Σ.Π.Ε - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "ΛΟΙΠΩΝ ΥΠΟΧΡΕΩΝ - (Λοιπόν Υπόχρεων) Αίτηση καταχώρισης αποδεικτικού φορολογικής δήλωσης",
        ),
        t(
          "ΛΟΙΠΩΝ ΥΠΟΧΡΕΩΝ - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
        t(
          "Ενεργειακή Κοινότητα - (Αυτοματοποιημένη Καταχώριση) Σχέδιο Σύμβασης Συγχώνευσης",
        ),
      ],
    },
    {
      label: t(
        "Υποβαλλόμενες στο ΓΕΜΗ με ευθύνη της ΑΕ και μέσω των Υπηρεσιών ΓΕΜΗ (για Έλεγχο, Καταχώριση και δημοσιότητα)",
      ),
      in: applicationSublistsOpen.b,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          b: !applicationSublistsOpen.b,
        });
      },
      items: [
        t("(ΑΕ) Αίτηση καταχώρησης απόφασης για αλλαγή διεύθυνσης γραφείων"),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση οικονομικών καταστάσεων» ME εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 07/07/2016 και META)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση οικονομικών καταστάσεων» ΧΩΡΙΣ εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 07/07/2016 και META)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης πρακτικού ΓΣ για την εκλογή ΔΣ και πρακτικού ΔΣ για την συγκρότηση αυτού σε σώμα και παροχής εξουσιοδοτήσεων",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρισης απόφασης ΓΣ για την Tροποποίηση καταστατικού",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρισης Γενικής Συνέλευσης κατά την οποία ΔΕΝ λήφθηκαν αποφάσεις δημοσιευτέες στο ΓΕΜΗ (παρ. 1 του άρθρου 134 του Ν. 4548/2018)",
        ),
        t(
          "(ΑΕ) Αίτηση Καταχώρισης Λοιπών αποφάσεων ΓΣ που υπόκεινται σε δημοσιότητα",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης Δ.Σ. για την Αύξηση Μετοχικού Κεφαλαίου (χωρίς τροποποίηση καταστατικού και ΑΝΩ των 3εκ. ευρώ)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης Δ.Σ. για την Αύξηση Μετοχικού Κεφαλαίου (χωρίς τροποποίηση καταστατικού και ΚΑΤΩ των 3εκ. ευρώ)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΔΣ για την μεταβολή ΔΣ, Ανασυγκρότηση ΔΣ ή/και αλλαγή Εκπροσώπησης",
        ),
        t(
          "(ΑΕ) Καταχώρηση απόφασης Διοικητικού Συμβουλίου για την πιστοποίηση καταβολής αύξησης μετοχικού κεφαλαίου (Ολική ή Μερική ή Μη Καταβολή)",
        ),
        t(
          "(ΑΕ) Καταχώρηση Απόφασης ΓΣ για θέση της εταιρίας σε Λύση & Εκκαθάριση και ορισμός εκκαθαριστών",
        ),
        t("(ΑΕ) Καταχώριση Ισολογισμού Έναρξης Εκκαθάρισης"),
        t(
          "(ΑΕ) Αίτηση Καταχώρησης Απόφασης ΓΣ για την έγκριση Ισολογισμού Πέρατος Εκκαθάρισης (με δημοσίευση του ισολογισμου) και για την ΔΙΑΓΡΑΦΗ της εταιρίας από το ΓΕΜΗ",
        ),
        t("(ΑΕ) Αίτηση καταχώρησης Μηνιαίων Λογιστικών Καταστάσεων Τραπεζών"),
        t(
          "(ΑΕ) Αίτηση καταχώρισης Ισολογισμού κατά Ε.Λ.Π - Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (παλαιές χρήσεις χωρίς αρχείο ΓΣ)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης Eνοποιημένων οικονομικών καταστάσεων και δημοσίευσης Eνοποιημένου ισολογισμού (ειδική περίπτωση)",
        ),
        t(
          "(ΑΕ) Καταχώριση οικονομικών καταστάσεων / συνοπτικών οικονομικών στοιχείων (Αφορά Ισολογισμούς χρήσεων 2014 ή παλαιότερες)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση οικονομικών καταστάσεων» (Χωρίς εκλογή ελεγκτών & χωρίς αλλαγή στοιχείων του ισολογισμού)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση τροποποιημένων οικονομικών καταστάσεων» και επαναδημοσίευση των τροποποιημένων στοιχείων (ισολογισμού κλπ.)",
        ),
        t(
          "(ΑΕ) Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση οικονομικών καταστάσεων» με εκλογή ελεγκτών",
        ),
      ],
    },
    {
      label: t(
        "Υποβαλλόμενες στο ΓΕΜΗ με ευθύνη της ΟΕ και μέσω των Υπηρεσιών ΓΕΜΗ (για Έλεγχο, Καταχώριση και δημοσιότητα)",
      ),
      in: applicationSublistsOpen.c,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          c: !applicationSublistsOpen.c,
        });
      },
      items: [
        t(
          "ΟΕ - Αίτηση καταχώρησης Ισολογισμού κατά Ε.Λ.Π. - Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 31/12/2015 και επόμενες)",
        ),
        t("ΟΕ - Αίτηση καταχώρησης τροποποίησης καταστατικού"),
        t(
          "ΟΕ - Αίτηση καταχώρησης απόφασης για λύση και θέση σε εκκαθάριση και ορισμό εκκαθαριστών",
        ),
        t("ΟΕ - Αίτηση Καταχώρισης Iσολογισμού Έναρξης Εκκαθάρισης"),
        t(
          "ΟΕ - Αίτηση Kαταχώρισης απόφασης για έγκριση ισολογισμού πέρατος εκκαθάρισης και διαγραφή από το ΓΕΜΗ",
        ),
        t(
          "ΟΕ - Αίτηση καταχώρησης απόφασης για οριστική λύση και διαγραφή χωρίς στάδιο εκκαθάρισης",
        ),
      ],
    },
    {
      label: t(
        "Υποβαλλόμενες στο ΓΕΜΗ με ευθύνη της ΕΕ και μέσω των Υπηρεσιών ΓΕΜΗ (για Έλεγχο, Καταχώριση και δημοσιότητα)",
      ),
      in: applicationSublistsOpen.d,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          d: !applicationSublistsOpen.d,
        });
      },
      items: [
        t(
          "ΕΕ - Αίτηση καταχώρησης Ισολογισμού κατά Ε.Λ.Π. - Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 31/12/2015 και επόμενες)",
        ),
        t("ΕΕ - Αίτηση καταχώρησης τροποποίησης καταστατικού"),
        t(
          "ΕΕ - Αίτηση καταχώρησης απόφασης για λύση και θέση σε εκκαθάριση και ορισμό εκκαθαριστών",
        ),
        t("ΕΕ - Αίτηση Καταχώρισης Ισολογισμού Έναρξης Εκκαθάρισης"),
        t(
          "ΕΕ - Αίτηση Kαταχώρισης απόφασης για έγκριση ισολογισμού πέρατος εκκαθάρισης και διαγραφή από το ΓΕΜΗ",
        ),
        t(
          "ΕΕ - Αίτηση καταχώρησης απόφασης για οριστική λύση και διαγραφή χωρίς στάδιο εκκαθάρισης",
        ),
      ],
    },
    {
      label: t(
        "Υποβαλλόμενες στο ΓΕΜΗ με ευθύνη της ΕΠΕ και μέσω των Υπηρεσιών ΓΕΜΗ (για Έλεγχο, Καταχώριση και δημοσιότητα)",
      ),
      in: applicationSublistsOpen.e,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          e: !applicationSublistsOpen.e,
        });
      },
      items: [
        t(
          "ΕΠΕ - Αίτηση καταχώρησης Ισολογισμού κατά Ε.Λ.Π. - Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 31/12/2015 και επόμενες)",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης για αλλαγή διεύθυνσης γραφείων, χωρίς αλλαγή δήμου",
        ),
        t("ΕΠΕ - Αίτηση καταχώρησης ισολογισμού έναρξης εκκαθάρισης"),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης για λύση και θέση σε εκκαθάριση και ορισμό εκκαθαριστών",
        ),
        t("ΕΠΕ - Αίτηση καταχώρησης Μηνιαίων Λογιστικών Καταστάσεων Τραπεζών"),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης της Συνέλευσης των Εταίρων για έγκριση ισολογισμού πέρατος εκκαθάρισης και διαγραφή από το ΓΕΜΗ",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης της Συνέλευσης των Εταίρων για την Tροποποίηση καταστατικού",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης Συνέλευσης Εταίρων για την «Έγκριση οικονομικών καταστάσεων» ME εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 07/07/2016 και META)",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης ΓΣ για την «Έγκριση οικονομικών καταστάσεων» ΧΩΡΙΣ εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά",
        ),
        t(
          "ΕΠΕ - Καταχώρηση οικονομικών καταστάσεων / συνοπτικών οικονομικών στοιχείων (Αφορά Ισολογισμούς χρήσεων 2014 ή παλαιότερες)",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης της Συνέλευσης των Εταίρων για την «Έγκριση τροποποιημένων οικονομικών καταστάσεων» και επαναδημοσίευση των τροποποιημένων στοιχείων (ισολογισμού κλπ.)",
        ),
        t(
          "ΕΠΕ - Αίτηση καταχώρησης απόφασης της Συνέλευσης των Εταίρων για την «Έγκριση οικονομικών καταστάσεων»",
        ),
      ],
    },
    {
      label: t(
        "Υποβαλλόμενες στο ΓΕΜΗ με ευθύνη της ΙΚΕ και μέσω των Υπηρεσιών ΓΕΜΗ (για Έλεγχο, Καταχώριση και δημοσιότητα)",
      ),
      in: applicationSublistsOpen.f,
      setOpen: () => {
        setApplicationSublistsOpen({
          ...applicationSublistsOpen,
          f: !applicationSublistsOpen.f,
        });
      },
      items: [
        t(
          "ΙΚΕ - Αίτηση καταχώρησης απόφασης για αλλαγή διεύθυνσης γραφείων, χωρίς αλλαγή δήμου",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρισης Ισολογισμού κατά Ε.Λ.Π. - Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 31/12/2015 και επόμενες)",
        ),
        t("ΙΚΕ - Αίτηση Καταχώρισης Ισολογισμού Έναρξης Εκκαθάρισης"),
        t(
          "ΙΚΕ - Αίτηση καταχώρισης απόφασης Συνέλευσης για την έγκριση Τροποποιημένων Οικονομικών Καταστάσεων και επαναδημοσίευση Ισολογισμού",
        ),
        t(
          "ΙΚΕ - Καταχώρηση Απόφασης της Συνέλευσης των Εταίρων για θέση της εταιρίας σε Λύση & Εκκαθάριση και ορισμός εκκαθαριστών",
        ),
        t(
          "ΙΚΕ - Αίτηση Καταχώρισης Απόφασης ΓΣ για την έγκριση ισολογισμού πέρατος εκκαθάρισης και διαγραφή της εταιρίας από το ΓΕΜΗ",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρησης απόφασης ΓΣ  για την Tροποποίηση καταστατικού",
        ),
        t("ΙΚΕ - Αίτηση καταχώρησης Μηνιαίων Λογιστικών Καταστάσεων Τραπεζών"),
        t(
          "ΙΚΕ - Αίτηση καταχώρησης απόφασης Συνέλευσης Εταίρων για την «Έγκριση οικονομικών καταστάσεων» ME εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 07/07/2016 και META)",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρησης απόφασης Συνέλευσης των Εταίρων για την «Έγκριση οικονομικών καταστάσεων» ΧΩΡΙΣ εκλογή ελεγκτών και Καταχώρισης Ισολογισμού κατά Ε.Λ.Π -Ελληνικά Λογιστικά Πρότυπα ή Δ.Λ.Π. (Αφορά Χρήσεις που λήγουν 07/07/2016 και META)",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρησης στο ΓΕΜΗ προσωρινών οικονομικών καταστάσεων και δημοσίευση ισολογισμού (Αφορά Ισολογισμούς χρήσεων 2014 ή παλαιότερες)",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρισης απόφασης Συνέλευσης για την έγκριση Οικονομικών Καταστάσεων (Αφορά Ισολογισμούς χρήσεων 2015 ή παλαιότερες)",
        ),
        t(
          "ΙΚΕ - Αίτηση καταχώρησης πρακτικού - απόφασης Διαχειριστή για την πιστοποίηση Αύξησης Εταιρικού Κεφαλαίου",
        ),
      ],
    },
  ];

  return (
    <Dialog maxWidth="xl" open={openApplicationDialog}>
      <DialogTitle
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {t("Υπηρεσία Ηλεκτρονικής Υποβολής Αιτήσεων Καταχώρισης στο ΓΕΜΗ")}
        </Typography>
        <IconButton onClick={() => setOpenApplicationDialog(false)}>
          <CloseOutlinedIcon sx={{ width: 30, height: 30 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography component="p" sx={{ lineHeight: "2rem" }}>
            {t(
              "Η Υπηρεσία αυτή υλοποιήθηκε σε εφαρμογή των διατάξεων των άρθρων 7 και 8 σε συνδυασμό με το άρθρο 4 του νόμου 4919/2022 όπως ισχύει και των Κοινών Υπουργικών Αποφάσεων Κ2-4946/2014 και 79752/2015. Χάρη στην υπηρεσία αυτή, κάθε επιχείρηση, εφόσον το επιθυμεί, θα διεκπεραιώνει τη συνολική διαδικασία υποβολής αιτήματος καταχώρισης στο ΓΕΜΗ, κατάθεσης των απαραίτητων δικαιολογητικών και πληρωμής των σχετικών τελών μέσω κατάλληλου περιβάλλοντος και με ειδικούς κωδικούς χρήστη και πρόσβασης στο σύστημα του ΓΕΜΗ, που θα εκδίδονται και θα χορηγούνται από τη Κεντρική Υπηρεσία Γ.Ε.ΜΗ. Ομοίως ηλεκτρονικά θα διεκπεραιώνεται και η διαδικασία ελέγχου, ολοκλήρωσης της καταχώρισης και έκδοσης περιληπτικής ανακοίνωσης για την καταχώριση. Ειδικά δε για τις Ανώνυμες Εταιρείες, ηλεκτρονικά θα γίνονται και οι διαδικασίες  διαβίβασης των δικαιολογητικών των Ανωνύμων Εταιρειών στις Περιφέρειες για άσκηση του εποπτικού ελέγχου και για έκδοση σχετικών αποφάσεων ή εγγράφων, όπου και όταν απαιτείται και η λήψη των σχετικών αποφάσεων ή εγγράφων των Περιφερειών.",
            )}
          </Typography>
          <Typography component="p" sx={{ lineHeight: "2rem" }}>
            {t(
              "Σχετικά με την υποβολή των αιτήσεων καταχώρισης και των σχετικών δικαιολογητικών στην «Υπηρεσία Ηλεκτρονικής Υποβολής Αιτήσεων Καταχώρισης στο ΓΕΜΗ» ενημερώνουμε τις επιχειρήσεις ότι:",
            )}
          </Typography>
          <Typography component="p" sx={{ lineHeight: "2rem" }}>
            {t(
              "Οι αιτήσεις καταχώρισης και τα δικαιολογητικά μπορούν να υποβάλλονται σε ψηφιακή μορφή, με ηλεκτρονικά μέσα και χωρίς χρήση ψηφιακής υπογραφής του εκδότη κάθε εγγράφου, εξοικονομώντας, έτσι, σημαντικό χρόνο από τις διαδικασίες αυτοπρόσωπης προσέλευσης και αναμονής στις διάφορες Υπηρεσίες (ΓΕΜΗ, Περιφερειών κλπ). Παράλληλα, καταργείται η υποχρέωση όσων χρησιμοποιήσουν την ως άνω Υπηρεσία να προσκομίσουν σε έντυπη μορφή, ταχυδρομικά ή με απλή προσέλευση, στο πρωτόκολλο των Υπηρεσιών ΓΕΜΗ τα σχετικά με την αίτηση καταχώρισης δικαιολογητικά.",
            )}
          </Typography>
          <Typography component="p" sx={{ lineHeight: "2rem" }}>
            {t(
              "Σημειώνουμε ότι η χρήση της «Υπηρεσία Ηλεκτρονικής Υποβολής Αιτήσεων Καταχώρισης στο ΓΕΜΗ» δεν είναι υποχρεωτική για όλες τις αιτήσεις και για όλες τις νομικές μορφές. Ωστόσο, ειδικά για τις κεφαλαιουχικές εταιρείες, ακόμα και αν ακολουθηθεί ο προηγούμενος τρόπος υποβολής αίτησης καταχώρισης, ήτοι με προσέλευση σε Υπηρεσία ΓΕΜΗ, τα υποβαλλόμενα έγγραφα πρέπει να είναι σε ψηφιακή μορφή, όπως ρητά ορίζεται στο τελευταίο εδάφιο της παρ. 3 του άρθρου 7 του ν. 4919/2022. Τέλος, σημειώνουμε ότι η Υπηρεσία θα εμπλουτίζεται σταδιακά με περισσότερες αιτήσεις καταχώρισης με στόχο να καλυφθούν τελικά όλα τα είδη αιτήσεων για όλες τις εταιρικές μορφές.",
            )}
          </Typography>
        </Box>
        <List>
          <ListItemButton
            onClick={() =>
              setApplicationSublistsOpen({
                ...applicationSublistsOpen,
                primary: !applicationSublistsOpen.primary,
              })
            }
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ListItemText
              primaryTypographyProps={{
                fontWeight: "bold",
                variant: "h5",
              }}
              primary={t("Διαθέσιμες αιτήσεις μεταβολών ανά νομική μορφή")}
            />
            <MenuOutlinedIcon />
          </ListItemButton>
          <Collapse
            in={applicationSublistsOpen.primary}
            timeout="auto"
            unmountOnExit
          >
            <List component="div" sx={{ padding: 1 }}>
              {sublists.map((sublist, index) => (
                <ListItem
                  key={index}
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ListItemButton
                    key={index}
                    onClick={sublist.setOpen}
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <ListItemText
                      key={index}
                      primaryTypographyProps={{
                        fontWeight: "bold",
                        variant: "h6",
                      }}
                      primary={sublist.label}
                    />
                    <MenuOutlinedIcon key={index} />
                  </ListItemButton>

                  <Collapse
                    in={sublist.in}
                    key={index}
                    sx={{ alignSelf: "start", mx: 6 }}
                  >
                    <List
                      component="div"
                      sx={{ listStyleType: "disc", alignSelf: "start" }}
                      key={index}
                    >
                      {sublist.items.map((item, i) => (
                        <ListItem key={i} sx={{ display: "list-item" }}>
                          <ListItemText key={i} primary={item} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </List>
      </DialogContent>
    </Dialog>
  );
}
